export class Upload {
  constructor(public file: File, public signedId?: string) {}
}
